// extracted by mini-css-extract-plugin
module.exports = {"emailInput":"_3JKX0","invalid":"l2ouQ"};